import React from "react"
import { Checkbox as MUICheckbox, CheckboxProps } from "@mui/material"
import { CheckedState, UncheckedState, IndeterminateState } from "./icons"
import { useStyles } from "./styles"

const Checkbox = React.forwardRef<any, CheckboxProps>((props, ref) => {
  const { classes, cx } = useStyles()

  return (
    <MUICheckbox
      {...props}
      ref={ref}
      icon={<UncheckedState />}
      checkedIcon={<CheckedState />}
      indeterminateIcon={<IndeterminateState />}
      focusVisibleClassName={classes.focused}
      className={cx(props.className, {
        [classes.selectedDisabled]: props.disabled && props.checked,
        [classes.unselectedDisabled]: props.disabled && !props.checked,
        [classes.unselectedNotDisabled]: !props.disabled && !props.checked
      })}
    />
  )
})

export default Checkbox
